import { render, staticRenderFns } from "./SwaggerUI.vue?vue&type=template&id=1eebc298&scoped=true"
import script from "./SwaggerUI.vue?vue&type=script&lang=ts"
export * from "./SwaggerUI.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eebc298",
  null
  
)

export default component.exports